var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.979 37.6665C8.91043 37.6665 6.1811 35.7019 5.19018 32.777L5.1231 32.5566C4.88927 31.7823 4.79152 31.1306 4.79152 30.479V17.4111L0.141682 32.9323C-0.456318 35.2151 0.906432 37.5821 3.19302 38.2127L32.8304 46.1496C33.2003 46.2455 33.5703 46.2915 33.9344 46.2915C35.8434 46.2915 37.5876 45.0245 38.0763 43.1577L39.8033 37.6665H11.979Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2493 17.5417C19.3634 17.5417 21.0827 15.8224 21.0827 13.7083C21.0827 11.5942 19.3634 9.875 17.2493 9.875C15.1353 9.875 13.416 11.5942 13.416 13.7083C13.416 15.8224 15.1353 17.5417 17.2493 17.5417Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2087 4.125H12.4587C9.81749 4.125 7.66699 6.2755 7.66699 8.91667V30C7.66699 32.6412 9.81749 34.7917 12.4587 34.7917H41.2087C43.8498 34.7917 46.0003 32.6412 46.0003 30V8.91667C46.0003 6.2755 43.8498 4.125 41.2087 4.125ZM12.4587 7.95833H41.2087C41.7377 7.95833 42.167 8.38767 42.167 8.91667V22.5231L36.1122 15.4583C35.4702 14.705 34.5406 14.3025 33.542 14.2795C32.5492 14.2852 31.6177 14.7261 30.9813 15.4889L23.8628 24.0334L21.5437 21.72C20.2327 20.409 18.0994 20.409 16.7903 21.72L11.5003 27.0081V8.91667C11.5003 8.38767 11.9297 7.95833 12.4587 7.95833Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.7442,
    y1: 5.15504,
    x2: 44.6784,
    y2: 39.6328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.0799,
    y1: 6.62146,
    x2: 23.8316,
    y2: 12.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3B84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5.98622,
    y1: -8.88917,
    x2: 53.7043,
    y2: 23.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3B84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0 0.291504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGallery);
export default __webpack_public_path__ + "static/media/image-gallery.b36cd66d204aa6f1322464c57126d520.svg";
export { ForwardRef as ReactComponent };